import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { AlertBubbleModule } from '../alert-bubble/alert-bubble.module';
import { AnimatedEllipsisModule } from '../animatedEllipsis/AnimatedEllipsisModule';
import { AreaMenuIconModule } from '../areaMenuIcon/AreaMenuIconModule';
import { FormsModule } from '../forms/FormsModule';
import { AngularUpgradeHelper } from '../helpers/AngularUpgradeHelper';
import { AreaMenuItemComponent } from './area-menu-item.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
    declarations: [
        AreaMenuItemComponent
    ],
    entryComponents: [
        AreaMenuItemComponent
    ],
    exports: [
        AreaMenuItemComponent
    ],
    imports: [
        AnimatedEllipsisModule,
        AlertBubbleModule,
        AreaMenuIconModule,
        CommonModule,
        FormsModule,
        MatCardModule,
        MatToolbarModule,
        MatButtonModule,
        MatIconModule,
        MatDividerModule,
    ],
})
export class AreaMenuItemModule {
    private commonModuleName = 'app.areas.common';

    constructor() {
        AngularUpgradeHelper.downgradeComponents(this.commonModuleName, [
            AreaMenuItemComponent
        ]);
    }
}
